(() => {
  function setup(root) {
    root.querySelectorAll('[data-gp-product-sections]:not([data-ready])').forEach(group => {
      group.dataset.ready = 'true';
      const source = group.querySelector('[data-gp-description]');
      // Unwrap presentation-only containers to preserve the original text and links.
      source.querySelectorAll('div').forEach(el => { if (!el.querySelector('table, img, video')) el.replaceWith(...el.childNodes); });
      source.querySelectorAll('li > p:first-child').forEach(p => { p.style.display = 'inline'; });
      // Join standalone numeric markers to their following paragraph without changing copy.
      Array.from(source.children).forEach(el => {
        if (/^\d+\.$/.test(el.textContent.trim()) && el.nextElementSibling?.tagName === 'P') {
          const next = el.nextElementSibling;
          const row = document.createElement('div'); row.className = 'gp-numbered-note';
          const number = document.createElement('span'); number.textContent = el.textContent.trim();
          el.replaceWith(row); row.append(number,next);
        }
      });
      const sections = new Map();
      let target = source;
      Array.from(source.children).forEach(el => {
        const lead = el.firstElementChild;
        const heading = lead && /^(STRONG|B|H[1-6])$/.test(lead.tagName) ? lead.textContent.trim() : '';
        const text = heading || el.textContent.trim();
        let title = '';
        if (text.length < 70 && !/[.!?]$/.test(text) && (heading || /^H[1-6]$/.test(el.tagName) || !el.children.length)) {
          if (/^(polisi|dasar|return|refund|pemulangan)/i.test(text)) title = 'PEMULANGAN & BAYARAN BALIK';
          else if (/^(penghantaran|delivery|shipping)/i.test(text)) title = 'PENGHANTARAN';
          else if (/^(nota|note|perhatian|disclaimer|penafian)/i.test(text)) title = 'NOTA PENTING';
          else if (/^(fabric|care|cara penjagaan|bahan|penjagaan)/i.test(text)) title = 'BAHAN & PENJAGAAN';
          else if (/^(size guide|size chart|panduan saiz|carta saiz)/i.test(text)) title = 'PANDUAN SAIZ';
        }
        if (title && document.documentElement.lang.split('-')[0] === 'en') title = ({'PEMULANGAN & BAYARAN BALIK':'RETURNS & REFUNDS','PENGHANTARAN':'DELIVERY','NOTA PENTING':'IMPORTANT NOTES','BAHAN & PENJAGAAN':'FABRIC & CARE','PANDUAN SAIZ':'SIZE GUIDE'})[title] || title;
        if (title && sections.has(title)) {
          target = sections.get(title);
        } else if (title) {
          const details = document.createElement('details');
          const summary = document.createElement('summary'); summary.textContent = title;
          const plus = document.createElement('span'); plus.textContent = '+'; plus.setAttribute('aria-hidden','true'); summary.append(plus);
          target = document.createElement('div'); target.className = 'gp-detail-content';
          details.append(summary,target); group.append(details);
          sections.set(title, target);
        }
        if (target !== source) target.append(el);
      });
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', e => setup(e.target));
})();

// Progressive collection browsing; Shopify pagination remains the no-JS fallback.
if (!customElements.get('gp-load-more')) customElements.define('gp-load-more', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.buffer = [];
    this.next = this.dataset.next;
    this.grid = this.parentElement.querySelector('#product-grid');
    this.button = this.querySelector('button');
    this.select = this.querySelector('select');
    this.status = this.querySelector('[role="status"]');
    this.en = this.dataset.en === 'true';
    this.button.addEventListener('click', () => this.load());
    this.update();
  }
  update() {
    const count = this.grid.children.length;
    this.status.textContent = this.en ? `${count} of ${this.dataset.total} products` : `${count} daripada ${this.dataset.total} produk`;
    const done = !this.next && !this.buffer.length;
    this.button.hidden = done;
    this.select.disabled = done;
  }
  async load() {
    if (this.busy) return;
    this.busy = true;
    this.button.disabled = true;
    this.select.disabled = true;
    this.setAttribute('aria-busy','true');
    const label = this.button.textContent;
    this.button.textContent = this.en ? 'Loading…' : 'Memuatkan…';
    const amount = Number(this.select.value);
    try {
      while (this.buffer.length < amount && this.next) {
        const url = new URL(this.next, location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid page');
        const response = await fetch(url.href, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Page unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = doc.querySelector('#product-grid');
        const controls = doc.querySelector('gp-load-more');
        if (!grid || !controls) throw new Error('Missing products');
        this.buffer.push(...Array.from(grid.children));
        this.next = controls.dataset.next;
      }
      const fragment = document.createDocumentFragment();
      const items = this.buffer.splice(0,amount);
      items.forEach(item => {
        item.classList.remove('scroll-trigger','animate--slide-in','scroll-trigger--offscreen');
        fragment.append(document.importNode(item,true));
      });
      if (!this.isConnected) return;
      const firstIndex = this.grid.children.length;
      this.grid.append(fragment);
      this.update();
      const firstLink = this.grid.children[firstIndex]?.querySelector('a');
      if (firstLink) firstLink.focus({preventScroll:true});
    } catch (error) {
      this.status.textContent = this.en ? 'Unable to load products. Please try again or use the page links below.' : 'Produk tidak dapat dimuatkan. Cuba lagi atau gunakan pautan halaman di bawah.';
      const fallback = this.parentElement.querySelector('.pagination-wrapper');
      if (fallback?.classList.contains('pagination-wrapper')) fallback.style.display = 'block';
    } finally {
      this.busy = false;
      this.button.disabled = false;
      this.select.disabled = !this.next && !this.buffer.length;
      this.button.textContent = label;
      this.removeAttribute('aria-busy');
    }
  }
});
